import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";
import { ROUTES } from "@/constants/navigation";
import { Button } from "@/components/UI/Button";
import { ButtonLink } from "@/components/UI/ButtonLink";
import "./HeaderAuthActions.css";

interface HeaderAuthActionsProps {
  size: "sm" | "lg";
  onNavigate?: () => void;
}

export function HeaderAuthActions({
  size,
  onNavigate,
}: HeaderAuthActionsProps) {
  const { t } = useTranslation();
  const { isAuthenticated, logout, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) return null;

  const handleLogout = async () => {
    await logout();
    navigate(ROUTES.home);
    onNavigate?.();
  };

  if (isAuthenticated) {
    return (
      <>
        <ButtonLink
          to={ROUTES.account}
          variant="secondary"
          size={size}
          className="site-header__account"
          onClick={onNavigate}
        >
          {t("actions.account")}
        </ButtonLink>
        <Button variant="secondary" size={size} onClick={handleLogout}>
          {t("actions.signOut")}
        </Button>
      </>
    );
  }

  return (
    <>
      <ButtonLink
        to={ROUTES.register}
        variant="inverted"
        size={size}
        className="site-header__register"
        onClick={onNavigate}
      >
        {t("actions.register")}
      </ButtonLink>
      <ButtonLink
        to={ROUTES.login}
        variant="primary"
        size={size}
        onClick={onNavigate}
      >
        {t("actions.signIn")}
      </ButtonLink>
    </>
  );
}
